// helpers
import setEnv from '@global/helpers/setEnv';
import excuteByDom from '@global/helpers/excuteByDom';

// globalUI
import { init as gotop } from '@global/components/global/gotop';
import accordion from '@global/components/global/accordion';
import hashAccordion from '@global/components/global/hashAccordion';
import floatLabel from '@global/components/global/floatLabel';
import focusInput from '@global/components/global/focusInput';
import formInputOrder from '@global/components/global/formInputOrder';
import Popup from '@global/components/global/popup';
import Navigation from './template/navigation_m22';
// import triggerSelect from 'components/global/triggerSelect'
import slideNotice from '@page/common/js/template/slideNotice';
import newsletterAndBookmark from '@page/common/js/template/newsletterAndBookmark';
import triggerSelect from '@page/common/js/template/triggerSelect';

//import Lightbox from '@global/components/global/Lightbox'

// promotion
import FooterNotice from '@global/components/promotion/footerNotice';

// expose functions to Global namespace
window.mercci22 = window.mercci22 || {};
window.mq = window.mercci22;
window.nowEnv = window.nowEnv || {};
window.nowBrand = window.mercci22;

var IgTagApiIs = '/Mercci22Style/GetHomeCarouselData';

// timer([2019, 1, 1, 0, 0, 0, 0], [2019, 1, 31, 18, 0, 0, 0], function () {
//   IgTagApiIs = '/Mercci22popup/GetHomeCarouselData'
// })

mercci22.constants = {
  addToCartUrl: '/Shopping/MiniCart/', // 加入迷你車
  addToCartUrl_Pre: '/Shopping/PreOrderMiniCart/', // 加入預購車
  addToWishList: '/Member/AddWishList/', // 加入願望清單
  GetBanners: '/Home/GetBanners', // 取得全域廣告
  loginMode: '/Member/IsLogin', // 取得登入狀態
  IgTag: IgTagApiIs, // ig 牆
};

mercci22.miniCartConfig = {
  cartCookieName: 'MiniCart',
  preCartCookieName: 'PreOrderMiniCart',
  wishlistProductSize: '.info p:nth-child(5)',
};

mercci22.globalConfig = {
  id: 'mercci22',
  name: 'Mercci22',
  devPort: '81',
  host: 'www.mercci22.com',
};

mercci22.imagePlaceholder = {
  default: 'https://static.tpx.tw/sff/mercci22/static/img/inf_800x1000.png',
};

function globalCtrl() {
  // environment
  nowEnv.NowIsDev = setEnv.isDev(); // 得知是否為本機開發環境
  nowEnv.NowIsTest = setEnv.isTest(); // 得知是否為測試環境
  nowEnv.NowMyEquipment = setEnv.myEquipment(); // 得知現在的裝置類型
  nowEnv.NowSmallScreen = setEnv.smallScreen(); // 得知現在是小於 480 的裝置
  nowEnv.NowIsLogin = setEnv.isLogin(); // 得知是否登入
  nowEnv.NowMyCookie = setEnv.myCookie(); // 得知目前裝置是否允許Cookie
  nowEnv.NowMyStorage = setEnv.myStorage(); // 得知目前裝置是否允許Storage
  setEnv.windowReload();

  // require component
  // const miniCart = require('./pages/cart/miniCart')

  // miniCart.init()
  // Lightbox.init()
  // template
  Navigation.navGlobal();
  newsletterAndBookmark.initNewsletterPopup();

  // globalUI
  triggerSelect();
  gotop('.ui-gotop', {
    toggle: { target: 200 },
    duration: 1500,
  });
  formInputOrder({
    inputArray: ['#account, #username', '#password', '#captchaTxt, #LoginCode'],
    submitButton: '#btnLogin, #btnShoppingLogin',
  });

  // condition
  if (nowEnv.NowMyEquipment) {
    // 手機版
    Navigation.navMobile();
    // promotion
    excuteByDom(() => {
      const footerNotice = new FooterNotice();
      footerNotice.init();
    }, ['#home-content']);
  } else {
    // 我是電腦版
    // template
    // miniCart.render()
    Navigation.navDesktop();
  }

  // expose functions to Global namespace
  //mercci22.miniCart = miniCart // 用來呼叫迷你車更新畫面用的喔
  mercci22.Notice = slideNotice;
  mercci22.popupType = 'englishBtn';
  mercci22.alert = Popup('alert');
  mercci22.confirm = Popup('confirm');
  mercci22.notice = Popup('notice');
}

export default globalCtrl;
